import { Box, Stack, Typography } from '@mui/material';
import { ReactComponent as PersonImage } from '@src/assets/icons/user_management.svg';
import CardDTO from '@src/adapters/dto/card/CardDTO';
import CardNoteDTO from '@src/adapters/dto/card/CardNoteDTO';
import { formatDate } from '@src/utils/dateUtils';

interface Props {
  card: CardDTO;
  note: CardNoteDTO;
}

export function NoteItem({ card, note }: Props) {
  return (
    <Box
      sx={{
        p: 3,
        '&:not(:last-child)': {
          borderBottom: '1px solid',
          borderColor: 'divider',
        },
      }}>
      <Stack direction="row" gap={2} mb={2} alignItems="center">
        <Box sx={{ display: 'inline-flex' }}>
          <PersonImage />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
          }}>
          <Typography variant="body2">
            {card?.consultant?.firstName} {card.consultant?.lastName}
          </Typography>
          <Typography variant="body2" color="#9DA5BA">
            {note.createdAt && formatDate(note.createdAt, 'DD/MM/YYYY HH:mm a')}
          </Typography>
        </Box>
      </Stack>

      <Typography variant="body1">{note.content}</Typography>
    </Box>
  );
}
